import { render, staticRenderFns } from "./Unpublished.vue?vue&type=template&id=3c4484a9&"
import script from "./Unpublished.vue?vue&type=script&lang=ts&"
export * from "./Unpublished.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports